<template>
  <el-form :inline="true" :model="form" class="gui-condition-item">
    <el-form-item>
      <el-input placeholder="括号" size="mini" v-model="form.leftBracket" class="gui-condition-bracket" readonly>
        <button slot="prepend" type="button" class="el-button" @click="setBracket('left', 1)">+</button>
        <button slot="append" type="button" class="el-button" @click="setBracket('left', -1)">-</button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-select placeholder="表" size="mini" v-model="form.table" @change="selectMetaTable" style="width:140px">
        <el-option v-for="t in metaTables" :key="t.name" :value="t.name" :label="t.name">
          {{ t.name }}<span class="mcd-option-desc">{{ t.cmt }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select placeholder="字段" size="mini" v-model="form.column" @change="selectMetaColumn" style="width:140px" no-data-text="请先选择表">
        <el-option v-for="c in metaTable.metaColumns" :key="c.name" :value="c.name" :label="c.name">
          {{ c.name }}<span class="mcd-option-desc">{{c.dataType}} - {{ c.cmt }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select placeholder="运算符" size="mini" v-model="form.operator" @change="selectOperator" style="width:100px">
        <el-option v-for="o in operators" :key="o.value" :value="o.value" :label="o.label"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input placeholder="值，多个以英文逗号隔开" size="mini" v-model="form.value" @change="onValueChange" style="width:170px"></el-input>
    </el-form-item>
    <el-form-item>
      <el-input placeholder="括号" size="mini" v-model="form.rightBracket" class="gui-condition-bracket" readonly>
        <button slot="prepend" type="button" class="el-button" @click="setBracket('right', 1)">+</button>
        <button slot="append" type="button" class="el-button" @click="setBracket('right', -1)">-</button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-radio-group v-model="form.combine" size="mini" @change="onCombineChange">
        <el-radio-button label="AND">与</el-radio-button>
        <el-radio-button label="OR">或</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item style="float:right;margin-right:0;">
      <el-button size="mini" icon="el-icon-close" type="danger" @click="close"></el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'gui-condition-item',
  props: {
    metaTables: { type: Array, required: true },
    leftBracket: { type: String, required: false, default: '' },
    table: { type: String, required: false, default: '' },
    column: { type: String, required: false, default: '' },
    operator: { type: String, required: false, default: '' },
    operatorType: { type: String, required: false, default: '' },
    value: { type: String, required: false, default: '' },
    rightBracket: { type: String, required: false, default: '' },
    combine: { type: String, required: false, default: '' }
  },
  data () {
    return {
      operators: [
        { value: '=', label: '等于', type: 'single' },
        { value: '>', label: '大于', type: 'single' },
        { value: '<', label: '小于', type: 'single' },
        { value: '>=', label: '大于等于', type: 'single' },
        { value: '<=', label: '小于等于', type: 'single' },
        { value: '<>', label: '不等于', type: 'single' },
        { value: 'IN', label: 'IN', type: 'range' },
        { value: 'NOT IN', label: 'NOT IN', type: 'range' },
        { value: 'IS NOT NULL', label: '不为空', type: 'none' },
        { value: 'IS NULL', label: '为空', type: 'none' }
      ],
      metaTable: {},
      metaColumn: {},
      form: {
        leftBracket: '',
        table: '',
        column: '',
        operator: '',
        operatorType: '',
        value: '',
        rightBracket: '',
        combine: ''
      }
    }
  },
  created () {
    this.form = {
      leftBracket: this.leftBracket,
      table: this.table,
      column: this.column,
      operator: this.operator,
      operatorType: this.operatorType,
      value: this.value,
      rightBracket: this.rightBracket,
      combine: this.combine
    }
  },
  methods: {
    selectMetaTable (value) {
      for (let metaTable of this.metaTables) {
        if (metaTable.name === value) {
          this.metaTable = metaTable
          break
        }
      }
      this.$emit('change')
    },
    selectMetaColumn (value) {
      for (let metaColumn of this.metaTable.metaColumns) {
        if (metaColumn.name === value) {
          this.metaColumn = metaColumn
          break
        }
      }
      this.$emit('change')
    },
    selectOperator (value) {
      for (let operator of this.operators) {
        if (operator.value === value) {
          this.form.operatorType = operator.type
          break
        }
      }
      this.$emit('change')
    },
    setBracket (type, value) {
      if (type === 'left') {
        if (value < 0) {
          if (this.form.leftBracket) {
            this.form.leftBracket = this.form.leftBracket.substring(1)
          }
        } else {
          this.form.leftBracket = this.form.leftBracket + '('
        }
      } else {
        if (value < 0) {
          if (this.form.rightBracket) {
            this.form.rightBracket = this.form.rightBracket.substring(1)
          }
        } else {
          this.form.rightBracket = this.form.rightBracket + ')'
        }
      }
      this.$emit('change')
    },
    onValueChange () {
      this.$emit('change')
    },
    onCombineChange () {
      this.$emit('change')
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style>
.gui-condition-item .el-form-item{margin-bottom:0}
.gui-condition-item .el-input input{padding:0 4px;}
.gui-condition-bracket{width:110px !important;}
.gui-condition-bracket>.el-input-group__prepend,.gui-condition-bracket>.el-input-group__append{padding:0 10px;cursor:pointer;user-select:none;}
</style>
